import { MatSnackBar } from "@angular/material/snack-bar"
import { NotificationMessageComponent } from "../components/notification-message/notification-message.component"

export const NOTIFICATIONS_CONFIG = {
  success: {
    message: 'NOTIFICATION.PORTFOLIO_SUCCESSFULLY_CREATED',
    iconClass: 'far fa-check-circle',
    panelClass: 'success-snackbar'
  },
  error: {
    message: 'NOTIFICATION.AN_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER',
    messageMax: 'NOTIFICATION.MAXIMUM_NUMBER_OF_CUSTOM_PORTFOLIOS_REACHED',
    iconClass: 'far fa-exclamation-circle',
    panelClass: 'error-snackbar'
  }
}

export function openSuccess(snackBar: MatSnackBar, message: string, duration: number = 0) {
  const { success } = NOTIFICATIONS_CONFIG;
  openNotification(snackBar, message || success.message, success.iconClass, success.panelClass, duration);
}

export function openError(snackBar: MatSnackBar, message: string, duration: number = 0) {
  const { error } = NOTIFICATIONS_CONFIG;
  openNotification(snackBar, message || error.message, error.iconClass, error.panelClass, duration);
}

export function openNotification(snackBar: MatSnackBar, message: string, iconClass: string, className: string, duration: number) {
  snackBar.openFromComponent(NotificationMessageComponent, {
    data: { message, iconClass },
    verticalPosition: 'top',
    duration: duration || 3000,
    panelClass: [className]
  });
}